import type { EndpointBuilder, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import type { TAGS } from "./common/tags";

export type SubscriptionApiBuilder = EndpointBuilder<
  ReturnType<typeof fetchBaseQuery>,
  typeof TAGS.SUBSCRIPTION,
  "subscriptionApi"
>;
